import { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import ChatDisplay from './ChatDisplay';
import ChatInput from './ChatInput';
import ApiHandler from './ApiHandler';
import RequestDisplay from './RequestDisplay';
import FilelistDisplay from './FilelistDisplay';

import { SendToCosmos, LoadToCosmos } from './SendToCosmos';

import defaultDataset from '../dataset';
import { ModeContext } from './ModeContext';
import { saveToCache, loadFromCache ,loadTitleCache} from './CacheHandler'; //チャット履歴をキャッシュに保存



const Main = ({ wkuser }) => {
    const [title, setTitle] = useState('');
    const { mode, setMode,
        messages, setMessages,
        sessionId, setSessionId,
        loginInfo, setIsComplete,
        setChatHistory, // ← 修正
        user,setUser ,
        dataset, setDataset,
        input, setInput,
        displayMode,
        isUploadMode,
        setUnreadCommentCount,
        currentRequestNumber, setCurrentRequestNumber } = useContext(ModeContext); // currentRequestNumberを追加

    const [currentId, setCurrentId] = useState('is_resolved');
    const TIMEOUT_MS = 10000; //タイムアウト設定

    // グローバルポーリング: 未読コメント数を定期的に更新
    useEffect(() => {
        // Admin, HQ, storeユーザーのみポーリングを実行
        if (!loginInfo.authorityId || !['admin', 'HQ', 'store'].includes(loginInfo.authorityId)) {
            return;
        }

        // 未読コメント数を取得する関数
        const fetchUnreadCommentCount = async () => {
            try {
                console.log('=== グローバルポーリング: 未読コメント数を取得 ===');
                
                let payload;
                if (loginInfo.authorityId === 'admin') {
                    // 管理者は全ての企業のデータを取得
                    payload = { 
                        id: 'all', 
                        container: 'con-concierge-request' 
                    };
                } else {
                    // HQ/storeは自分の企業のデータのみ取得
                    payload = { 
                        id: loginInfo.compId, 
                        container: 'con-concierge-request' 
                    };
                }

                const result = await LoadToCosmos(payload);
                
                // データから未読コメント数を計算
                let allRequests = [];
                
                // Admin権限の場合の処理
                if (loginInfo.authorityId === 'admin' && result && result.item) {
                    if (Array.isArray(result.item)) {
                        // 複数企業データの場合
                        result.item.forEach(companyData => {
                            if (companyData.messages && typeof companyData.messages === 'object') {
                                Object.entries(companyData.messages).forEach(([storeId, storeData]) => {
                                    if (storeData.messages && Array.isArray(storeData.messages)) {
                                        storeData.messages.forEach(category => {
                                            if (category.messages && Array.isArray(category.messages)) {
                                                allRequests.push(...category.messages);
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    } else if (result.item.messages && typeof result.item.messages === 'object') {
                        // 単一企業データの場合
                        Object.entries(result.item.messages).forEach(([storeId, storeData]) => {
                            if (storeData.messages && Array.isArray(storeData.messages)) {
                                storeData.messages.forEach(category => {
                                    if (category.messages && Array.isArray(category.messages)) {
                                        allRequests.push(...category.messages);
                                    }
                                });
                            }
                        });
                    }
                } else if (result && result.item && result.item.messages) {
                    // HQ/Store権限の場合の処理
                    Object.entries(result.item.messages).forEach(([storeId, storeData]) => {
                        if (storeData.messages && Array.isArray(storeData.messages)) {
                            storeData.messages.forEach(category => {
                                if (category.messages && Array.isArray(category.messages)) {
                                    category.messages.forEach(request => {
                                        // 店舗ユーザーは自分の店舗のデータのみ
                                        if (loginInfo.authorityId === 'store' && storeId !== loginInfo.userId) {
                                            return;
                                        }
                                        allRequests.push(request);
                                    });
                                }
                            });
                        }
                    });
                }

                // 未読コメント数を計算
                const unreadCount = allRequests.reduce((total, request) => {
                    // 未読コメント数を計算
                    const requestUnreadCount = (request.comments || []).filter(comment => 
                        comment.unreadFor && comment.unreadFor.includes(loginInfo.authorityId)
                    ).length;
                    
                    // 未読依頼かどうかをチェック（依頼自体が未読の場合）
                    const isUnreadRequest = (request.unreadFor && request.unreadFor.includes(loginInfo.authorityId)) ? 1 : 0;
                    
                    return total + requestUnreadCount + isUnreadRequest;
                }, 0);

                console.log('=== 未読コメント数+未読依頼数:', unreadCount, '===');
                setUnreadCommentCount(unreadCount);

            } catch (error) {
                console.error('グローバルポーリング: 未読コメント数取得エラー:', error);
            }
        };

        // 初回実行
        fetchUnreadCommentCount();

        // 30秒ごとに実行
        const pollingInterval = setInterval(fetchUnreadCommentCount, 30000); // 30秒

        // クリーンアップ
        return () => {
            console.log('=== グローバルポーリング: 停止 ===');
            clearInterval(pollingInterval);
        };
    }, [loginInfo.authorityId, loginInfo.compId, loginInfo.userId, setUnreadCommentCount]);

    // リロード時にCosmosDBから履歴を取得してキャッシュに保存
    useEffect(() => {
        const loadHistoryFromCosmos = async () => {
            try {
                // loginInfoからuserIdとcompIdを取得
                const userId = loginInfo.userId;
                const compId = loginInfo.compId;
                
                if (!userId) {
                    return;
                }
                
                // CosmosDBからユーザーの履歴を取得
                const payload = {
                    userId: userId,
                    compId: compId,
                    container: 'con-concierge-hist'
                };
                
                const result = await LoadToCosmos(payload);
                
                if (result && result.item && result.item.messages) {
                    // 取得した履歴をキャッシュに保存
                    const cache = await caches.open('chat-history-cache');
                    await cache.put('chat-sessions', new Response(JSON.stringify(result.item.messages)));
                    
                    // chatHistoryステートも更新
                    setChatHistory(result.item.messages);
                }
            } catch (error) {
                console.error('履歴取得エラー:', error);
            }
        };
        
        // loginInfo.userIdが存在する場合のみ実行
        if (loginInfo.userId || loginInfo.id) {
            loadHistoryFromCosmos();
        }
    }, [loginInfo, setChatHistory]);

    useEffect(() => {
        loadFromCache('chat-history-cache', sessionId).then(result => {
            setTitle(result?.title ?? input);
        });
    }, [sessionId]);

    useEffect(() => {
        const data = loginInfo.data;
        let initialQuestion = {};
        let datasetToUse = {};
        
        if (data.init === 'none') {
            initialQuestion = defaultDataset.init;
            console.log("defaultDataset typeof", typeof defaultDataset);
            setDataset(defaultDataset);
            datasetToUse = defaultDataset;
        } else {
            initialQuestion = data.init;
            setDataset(data);
            datasetToUse = data;
        }

        if (!sessionId) {
            setSessionId(crypto.randomUUID());
        }
        console.log('initialQuestion', initialQuestion);
        if (initialQuestion) {
            // 初期メッセージのアイコンとモードは、最初のanswerが指すnextIdから取得
            let initialIcon = initialQuestion.icon;
            let initialMode = initialQuestion.mode;
            
            // 最初のanswerが存在し、nextIdが設定されている場合
            if (initialQuestion.answers && initialQuestion.answers.length > 0) {
                const firstAnswer = initialQuestion.answers[0];
                if (firstAnswer.nextId && datasetToUse[firstAnswer.nextId]) {
                    const firstNextMessage = datasetToUse[firstAnswer.nextId];
                    // アイコンの優先順位: firstAnswer.icon > firstNextMessage.icon > initialQuestion.icon
                    initialIcon = firstAnswer.icon || firstNextMessage.icon || initialIcon;
                    // モードは最初のnextIdのmodeを使用
                    initialMode = firstNextMessage.mode || initialMode;
                } else if (firstAnswer.icon) {
                    // nextIdがない場合でもanswerにiconがあれば使用
                    initialIcon = firstAnswer.icon;
                }
            }
            
            setMessages([
                {
                    id: crypto.randomUUID(),
                    sender: initialMode,
                    text: initialQuestion.question,
                    buttons: initialQuestion.answers.map((ans) => ({
                        label: ans.content,
                        nextId: ans.nextId,
                        init:ans.init,
                        icon: ans.icon
                    })),
                    mode: initialMode,
                    icon: initialIcon,
                    timestamp: Date.now()
                },
            ]);
            handleModeChange(initialMode);
        }
    }, [currentId, setMessages]);

    useEffect(() => { }, [dataset]);

    useEffect(() => {
        // 最後のメッセージを取得
        const lastMsg = messages[messages.length - 1];
        if (lastMsg?.sender === 'user') {
            // タイムアウト監視開始
            const timer = setTimeout(() => {
                console.warn("⏱ タイムアウト発生");

                const timeoutMsg = {
                    id: crypto.randomUUID(),
                    sender: mode,
                    text: 'ごめんなさい。タイムアウトが発生しました。<br>サーバーから応答がありません。',
                    mode: mode,
                    timestamp: Date.now()
                };

                setMessages(prev => {
                    const updated = [...prev, timeoutMsg];

                    const timestamp = Date.now();
                    const title = lastMsg.text ?? '未定義タイトル';

                    // Cosmos 保存も実施
                    saveHistoryToCosmos(
                        sessionId,
                        title,
                        updated,
                        timestamp,
                        mode,
                        setChatHistory,
                        user
                    );

                    return updated;
                });
            }, 12000); // ← 例: 12秒

            return () => clearTimeout(timer); // cleanup
        }
    }, [messages, mode]);


    useEffect(() => {
        if (wkuser && wkuser.length > 0) {
            setUser(wkuser);
        }
    }, [wkuser]);

    const handleModeChange = (mode) => {
        console.log('handleModeChange')
        setMode(mode);
    };

    const handleSubmit = async (e, message,editmessages) => {
        console.log('handleSubmit',message,mode)

//        const { nextId, label, mode } = message;
        const { icon,label,nextId} = message;

        const lastMessage = messages[messages.length - 1]
        if (message.nextId !== "dummy" && ("nextId" in message)) {
//        if(message.init){ //メッセージの最初
            const nextmessage=dataset[message.nextId]
            setMessages((prev) => [...prev, 
                {
                    id:crypto.randomUUID(),
                    sender: nextmessage.mode,
                    text: `${message.label}ですね。<br>${nextmessage.question}`,
                    buttons: nextmessage.answers.map((ans) => ({
                    label: ans.content,
                    nextId: ans.nextId,
                    init: ans.init,
                    icon: ans.icon,
                    img: ans.img,
                    })),
                    mode: nextmessage.mode,
                    icon: message.icon || nextmessage.icon, // ボタンのアイコンまたは次メッセージのアイコンを設定
                    isInitialQuestion: true, // 初期質問フラグを追加
                    timestamp: Date.now()
                },
            ]);
            setMode(nextmessage.mode);
        }else{
            e?.preventDefault();
            //入力、編集質問を取得
            const userInput = message.label ?? message.text;
            const image = message.image
            const imagemessage = message.imagemessage
            
            if (!userInput.trim()) return;

            const timestamp = Date.now();

            let newMessages
            let newMessage
            if (editmessages){//メッセージの途中編集からの質問か？
                //newMessage = { sender: 'user', text: userInput, mode:mode ,image:image};
                newMessage = { id: crypto.randomUUID(),sender: 'user', text: userInput , mode:mode ,image:image,imagemessage:imagemessage, timestamp: timestamp};
                //newMessages = editmessages;
                newMessages = [...editmessages, newMessage];                   
            }else{
                newMessage = { id: crypto.randomUUID(),sender: 'user', text: userInput, mode:mode ,image:image,imagemessage:imagemessage, timestamp: timestamp};
                newMessages = [...messages, newMessage];
            }

            switch (mode) {
            case 'faq':
                func_faq(e, timestamp, title,newMessages,newMessage);
                break                
            case 'manual':
                func_manual(e, timestamp, title,newMessages,newMessage);
                break
            case 'support':
                func_support(e, timestamp, title,newMessages,newMessage);
                break
            case 'sendbak':
                func_sendbak(e, timestamp, title,newMessages,newMessage);
                break
            case 'chatgpt':
                func_chatgpt(e, timestamp, title,newMessages,newMessage);
                break
            case 'faqdoc':
                func_faqdoc(e, timestamp, title,newMessages,newMessage);
                break
            case 'csiaction':
                func_csiaction(e, timestamp, title,newMessages,newMessage);
                break
            case 'csinote':
                func_csinote(e, timestamp, title,newMessages,newMessage);
                break
            case 'faqchat':
                func_faqchat(e, timestamp, title,newMessages,newMessage);
                break
            default:
                break
            }

            saveToCache(sessionId, 'chat-history-cache', userInput, newMessages, timestamp, mode, setChatHistory);

        }

        setInput('');
    };

    const func_chatgpt = (e, timestamp, title,newMessages,newMessage) => {
//        func_userinp(message);
        setMessages(newMessages);

        const filterMessages = newMessages.filter(item => item.mode === "chatgpt" && !item.isInitialQuestion);
        ApiHandler.search(newMessage.text, filterMessages, 'test_user', mode, loginInfo, setMessages)
            .then(result => updateMessagesAI(result, timestamp, title));
    };

    const func_sendbak = (e, timestamp, title,newMessages,newMessage) => {

        setMessages(newMessages);
        const filterMessages = newMessages.filter(item => item.mode === "sendbak" && item.status !== "done" && !item.isInitialQuestion);
        ApiHandler.search(newMessage.text, filterMessages, 'test_user', mode, loginInfo,setMessages)
            .then(result => {
                if (result.includes('end_of_talk')) {
                    //const answers = [{ content: "依頼", nextId: "yes_support" }, { content: "キャンセル", nextId: "no_support" }];
                    //updateMessages(result, timestamp, title, answers);
                    updateMessagesAI(result, timestamp, title);
                } else {
                    updateMessagesAI(result, timestamp, title);
                }
            });
    };

    const func_support = (e, timestamp, title,newMessages,newMessage) => {
        setMessages(newMessages)

        // 初期質問を除外し、実際のユーザー入力とAI応答のみをフィルタリング
        const filterMessages = newMessages.filter(item => 
            item.mode === "support" && 
            item.status !== "done" &&
            !item.isInitialQuestion // 初期質問フラグがないものだけ
        );
        ApiHandler.search(newMessage.text, filterMessages, 'test_user', mode, loginInfo,setMessages)
            .then(result => {
                // resultがオブジェクトで、requestNumberが含まれている場合は保存
                if (typeof result === 'object' && result.requestNumber) {
                    setCurrentRequestNumber(result.requestNumber);
                    console.log('受付番号を保存しました:', result.requestNumber);
                    result = result.message; // messageのみを使用
                }
                
                if (result.includes('end_of_talk')) {
                    const answers = [{ content: "依頼", nextId: "yes_support" }, { content: "キャンセル", nextId: "no_support" }];

                    updateMessagesAI(result, timestamp, title);
                } else {
                    updateMessagesAI(result, timestamp, title);
                }
            });
    };

    const func_faq = (e, timestamp, title,newMessages,newMessage) => {
        setMessages(newMessages);
        const filterMessages = newMessages.filter(item => item.mode === "faq" && !item.isInitialQuestion);
        ApiHandler.search(newMessage.text, filterMessages, 'test_user', mode, loginInfo)
            .then(result => updateMessages(result, timestamp, title));
    };

    const func_manual = (e, timestamp, title,newMessages,newMessage) => {
        setMessages(newMessages);
        //func_userinp(newMessage.label);

        const filterMessages = newMessages.filter(item => item.mode === "manual" && !item.isInitialQuestion);
        ApiHandler.search(newMessage.text, filterMessages, 'test_user', mode, loginInfo,setMessages)
            .then(result => updateMessagesAI(result, timestamp, title));
    };

    const func_faqdoc = (e, timestamp, title,newMessages,newMessage) => {
        setMessages(newMessages);
        
         //func_userinp(newMessage.label);

        const filterMessages = newMessages.filter(item => item.mode === "faqdoc" && !item.isInitialQuestion);
        ApiHandler.search(newMessage.text, filterMessages, 'test_user', mode, loginInfo,setMessages)
            .then(result => updateMessagesAI(result, timestamp, title));
    };

    const func_csiaction = (e, timestamp, title,newMessages,newMessage) => {

        setMessages(newMessages);
        //func_userinp(newMessage.label);
        const filterMessages = newMessages.filter(item => item.mode === "csiaction" && !item.isInitialQuestion);
        ApiHandler.search(newMessage.text, filterMessages, 'test_user', mode, loginInfo,setMessages)
            .then(result => updateMessagesAI(result, timestamp, title,""));
    };

    const func_csinote = (e, timestamp, title,newMessages,newMessage) => {

        setMessages(newMessages);
        const filterMessages = newMessages.filter(item => item.mode === "csinote" && !item.isInitialQuestion);
        ApiHandler.search(newMessage.text, filterMessages, 'test_user', mode, loginInfo,setMessages)
            .then(result => updateMessagesAI(result, timestamp, title,""));
    };

    const func_faqchat = (e, timestamp, title,newMessages,newMessage) => {

        setMessages(newMessages);
        //func_userinp(newMessage.label);
        const filterMessages = newMessages.filter(item => item.mode === "faqchat" && !item.isInitialQuestion);
        ApiHandler.search(newMessage.text, filterMessages, 'test_user', mode, loginInfo,setMessages)
            .then(result => updateMessagesAI(result, timestamp, title,""));
    };


//OpenAI用メッセージ更新（ストリーミングで既にメッセージは追加済みのため、履歴保存のみ行う）
    const updateMessagesAI = (result, timestamp, title, answers) => {

        setTimeout(() => {

            setMessages(prev => {
                // ストリーミング中にRequestコンポーネント側でsetMessagesにより
                // ボットの応答は既に追加されているため、ここでは新規追加しない。
                // answersがある場合は最後のメッセージにボタンを付与する。
                let updated;
                if (answers) {
                    updated = [...prev];
                    const lastMsg = updated[updated.length - 1];
                    if (lastMsg && lastMsg.sender !== 'user') {
                        lastMsg.buttons = answers.map(ans => ({
                            label: ans.content,
                            nextId: ans.nextId
                        }));
                    }
                } else {
                    updated = prev;
                }

                saveHistoryToCosmos(
                    sessionId,
                    title,
                    updated,
                    timestamp,
                    mode,
                    setChatHistory,
                    user
                );
                return updated;
            });
            setIsComplete(true);//メッセージ終了後ボタンをEnable
        }, 100);
    };


    const updateMessages = (result, timestamp, title, answers = null) => {
        const represult = result.replace(/\n{3,}/g, '\n\n');
        setTimeout(() => {
            setMessages(prev => {
                const newMsg = {
                    id: crypto.randomUUID(),
                    sender: mode,
                    text: represult,
                    mode,
                    timestamp: Date.now()
                };
                if (answers) {
                    newMsg.buttons = answers.map(ans => ({
                        label: ans.content,
                        nextId: ans.nextId
                    }));
                }
                const updated = [...prev, newMsg];
                
                saveHistoryToCosmos(
                    sessionId,
                    title,
                    updated,
                    timestamp,
                    mode,
                    setChatHistory,
                    user
                );
                return updated;
            });
             setIsComplete(true);//メッセージ終了後ボタンをEnable
        }, 100);
    };

    const saveHistoryToCosmos = async (
        sessionId,
        title,
        updated,
        timestamp,
        mode,
        setChatHistory,
        user
    ) => {
        // 1. キャッシュ保存
        await saveToCache(sessionId, 'chat-history-cache', title, updated, timestamp, mode, setChatHistory);
 
        // 2. キャッシュから取得
        let payload = await loadTitleCache('chat-history-cache');
        payload = payload.slice(0, 50);//履歴50まで保持

        // loginInfoからuserIdとcompIdを取得
        const userId = loginInfo.userId;
        const compId = loginInfo.compId;
        
        // 3. CosmosDBに送信するペイロード作成
        // con-concierge-histのid形式: compIdがある場合は "compId-userId"、ない場合は "userId"
        const historyId = compId ? `${compId}-${userId}` : userId;
        
        let uppayload = {
            id: historyId,
            timestamp: Date.now(),
            messages: payload,
            container: "con-concierge-hist"
        };

        // 4. CosmosDBに送信
        await SendToCosmos(uppayload);

        //ナレッジの蓄積　初回（いいねボタンを押していないかの判断）
        const lastMsg = updated[updated.length - 1];
        if (!lastMsg?.feedbackDone) {// || actionType
            //ナレッジをCosmosDBに保存
            const uppayload2 = {
                id: updated[updated.length - 1]?.id,
                user:loginInfo.id,
                compId:loginInfo.compId,
                compName:loginInfo.compName,
                mode:mode,
                timestamp: Date.now(),
                feedback:'',
                groupId: localStorage.getItem('groupId') || '',
                question:[...updated].reverse().find(msg => msg.sender === "user")?.text,
                answer:updated[updated.length - 1]?.text,
                container: "con-concierge-knowledge",
                updatetype:'all'
            };
            await SendToCosmos(uppayload2);
        }

        return updated;
    };

    const handleSendMessage = (inputValue) => {
        if (!inputValue.trim()) return;
        setTimeout(() => {
            setMessages((prevMessages) => [
                ...prevMessages,
                { id: crypto.randomUUID(),sender: 'user', text: inputValue, type: 'free', nextId: 'none', mode: 'none', timestamp: Date.now() },
            ]);
        }, 200);
    };

    const handleSearch = async (query) => {
        console.log(`Main_Search triggered with query: ${query}`);
    };

    return (
        <div className="chat-container">
            {displayMode === 'request' ? (
                <RequestDisplay />
            ) : isUploadMode ? (
                <FilelistDisplay />
            ) : (
                <>
                    <ChatDisplay
                        onButtonClick={(buttonText) => handleSubmit(null, buttonText)} // ボタンでhandleSubmitを呼ぶ
                        onSubmit={handleSubmit}
                        saveHistoryToCosmos={saveHistoryToCosmos} // 履歴保存
                    />
                    <div className="chat-input">
                        <ChatInput
                            onSendMessage={handleSendMessage}
                            onSearch={handleSearch}
                            onSubmit={handleSubmit} // ChatInputでもhandleSubmitを使える
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default Main;